import BaseModel from "../base_model.js";

import { SignUpPersonalInfoModel } from "./sign_up_personal_info_model.js";

import { InputLabelDisplayModeAbove } from "../../base/inputs/constants.js";

class RawSignUpInfoModel extends BaseModel {

  rawFormFields(item = undefined) {
    return [
      {
        name: "personalInfo",
        type: "nestedModel",
        model: SignUpPersonalInfoModel
      },
      {
        name: "password",
        displayName: this.fieldDisplayName("password"),
        type: "password",
        displayNamePosition: InputLabelDisplayModeAbove
      }
    ]
  }

  i18nScope() {
    return "model.users.user";
  }

}
const SignUpInfoModel = new RawSignUpInfoModel();

export { RawSignUpInfoModel, SignUpInfoModel }

